module.exports = __webpack_public_path__ + "static/domek-6d4ed79f595bcfc551fa461ca81cf84e.jpg";